import SvgIcon from "@mui/material/SvgIcon";
import { makeStyles } from "@mui/styles";
import { memo } from "react";

const useStyles = makeStyles({
  icon: {
    height: "1.5rem",
    width: "1.5rem",
  },
});

export const DPDLogoIcon = memo(() => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 21 24" className={styles.icon}>
      <path
        d="M19.8602 5.19632L19.5784 5.37503C17.5339 6.57575 15.495 7.78206 13.4451 8.9772C13.2017 9.08792 13.0582 9.34618 13.0915 9.61386C13.1301 10.3287 13.0915 10.2394 13.6772 10.608C13.885 10.7721 14.1748 10.779 14.3899 10.6247C16.2686 9.50775 18.1583 8.3908 20.037 7.27385L20.3796 7.07838C20.3837 7.15651 20.3837 7.23481 20.3796 7.31294V17.5386C20.3869 17.8856 20.1923 18.2047 19.8823 18.354L13.528 22.1572C12.6052 22.7157 11.6769 23.2742 10.7652 23.8327C10.442 24.0558 10.0165 24.0558 9.69329 23.8327C6.65427 22.0009 3.61526 20.184 0.576247 18.3819C0.219003 18.1989 0.00230935 17.82 0.0236973 17.4158C0.0236973 14.0649 0.0236973 10.7308 0.0236973 7.41347C0.0236973 7.31294 0.0236973 7.218 0.0236973 7.07838L0.327599 7.24592L8.97498 12.3281C9.17192 12.4147 9.29048 12.6204 9.26783 12.8363C9.26783 15.3159 9.26783 17.79 9.26783 20.2696V20.5209C9.26064 20.6865 9.35199 20.8403 9.4999 20.9118L9.96404 21.1743C10.1101 21.2637 10.2932 21.2637 10.4392 21.1743L10.8813 20.9286C11.0405 20.8596 11.1384 20.6955 11.1244 20.5209C11.1244 20.4539 11.1244 20.3869 11.1244 20.3199V11.898C11.1244 11.8198 11.1244 11.7472 11.1244 11.6691C11.1297 11.5158 11.0482 11.3728 10.9144 11.3005L10.2127 10.8872L0.863571 5.37503L0.576247 5.2019L0.808318 5.03994L9.64909 0.158859C9.98765 -0.052953 10.4156 -0.052953 10.7542 0.158859C13.7103 1.80078 16.6554 3.41478 19.6005 5.03994L19.8602 5.19632Z"
        fill="white"
      />
    </SvgIcon>
  );
});
